import React from 'react';
import USBAccordion from '@usb-shield/react-accordion';
import ReactHtmlParser from 'react-html-parser';
import { USBIconChevronRight } from '@usb-shield/react-icons';
import '@usb-shield/react-accordion/dist/library/styles/scss/index.scss';
import styles from './dpsProductListAccordian.scss';
import { linkGenerator } from '../../utils';
import defaultLang from '../../language';

function DspProductListAccordian({
    productId,
    id,
    context,
    reportingDataOnClickEvent,
}) {
    const learnMoreLinkGenerator = (string) => {
        const { href, target, text } = linkGenerator(string);
        const onClickLearnMore = () => {
            reportingDataOnClickEvent(
                defaultLang.siteCat.learnMoreLink,
                productId,
            );
        };
        return (
            <a target={target} href={href} onClick={onClickLearnMore}>
                <span>
                    {text}
                    <USBIconChevronRight />
                </span>
            </a>
        );
    };
    const featuresList = context?.sellingPoints?.map((item) => {
        const onFeatureClick = () => {
            reportingDataOnClickEvent(
                defaultLang.siteCat.featuresLink,
                productId,
            );
        };
        return (
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
            <li
                className="feature-container-list"
                key={item}
                onKeyDown={() => {}}
                onClick={onFeatureClick}
            >
                {ReactHtmlParser(`${item}`)}
            </li>
        );
    });
    const learnmoreList = context?.businessSelectorLearnMoreUrl?.map(
        (item) => (
            <li className="learnmore-link" key={item}>
                {learnMoreLinkGenerator(item)}
            </li>
        ),
    );
    const handleProductLinkClick = (e) => {
        reportingDataOnClickEvent(
            e.currentTarget.innerText === 'Features'
                ? defaultLang.siteCat.featuresLink
                : defaultLang.siteCat.learnMoreLink,
            productId,
        );
    };
    return (
        <div>
            <USBAccordion
                id={`product-${id}-accordian`}
                key={`product-${id}-accordian`}
                accordionType="large"
                addClasses="test-class"
                panelToExpand=""
                handleClick={handleProductLinkClick}
                accordions={[
                    {
                        title: 'Features',
                        id: 1,
                        children: (
                            <ul
                                className={
                                    styles['feature-container']
                                }
                            >
                                {featuresList}
                            </ul>
                        ),
                    },
                    {
                        title: 'Learn more',
                        id: 2,
                        children: (
                            <ul
                                className={
                                    styles['learnmore-container']
                                }
                            >
                                {learnmoreList}
                            </ul>
                        ),
                    },
                ]}
            />
        </div>
    );
}

export default DspProductListAccordian;
